var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInsights128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 54.5029H40",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.4 0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 38.5029H50",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.4 0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9443 21.7871H67.0765",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.4 0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2954 78.8164L108.876 106.918",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1043 88.9381C85.0716 88.9381 98.0157 75.994 98.0157 60.0267C98.0157 44.0593 85.0716 31.1152 69.1043 31.1152C53.137 31.1152 40.1929 44.0593 40.1929 60.0267C40.1929 75.994 53.137 88.9381 69.1043 88.9381Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1045 81.0468C80.7113 81.0468 90.1205 71.6376 90.1205 60.0307C90.1205 48.4239 80.7113 39.0146 69.1045 39.0146C57.4976 39.0146 48.0884 48.4239 48.0884 60.0307C48.0884 71.6376 57.4976 81.0468 69.1045 81.0468Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInsights128);
export default __webpack_public_path__ + "static/media/pictogramBeaconInsights128.f965b0860801bfb6c96d7a5eb0a4295d.svg";
export { ForwardRef as ReactComponent };